import { createContext } from "react";

const ContextDashboard = createContext();

export default ContextDashboard;